import './MediaGrid.css';
import React, { useEffect } from 'react';
import { get } from '../../utils';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import MediaCarousel, { commonStyles, ltrStyles, rtlStyles } from '../28_MediaCarousel/MediaCarousel';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { hideContainerByChild } from '../../utils';
import ScrollAnimation from 'react-animate-on-scroll';
import { convertToAnalyticObject } from '../../utils/analytics';
// @ts-ignore
var MediaGrid = function MediaGrid(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var dataItems = get(fields, 'data.item', {});
  var hasItems = Boolean(get(fields, 'data.item.children.length')) || Boolean(get(dataItems, 'mediaItems.targetItems', []));
  var hasCaption = Boolean(get(fields, 'data.item.caption.jss.value'));
  var showFullWidthImages = Boolean(get(fields, 'data.item.showFullImages.jss.value')) || false;
  var eAnalytics = get(fields, 'data.eventsAnalytics');
  var eventsAnalytics;
  if (eAnalytics) {
    eventsAnalytics = convertToAnalyticObject(eAnalytics);
  }
  var mediaItems = get(dataItems, 'mediaItems.targetItems', []);
  var items = mediaItems.length ? mediaItems : get(dataItems, 'children', []);
  var showAsCarousel = get(fields, 'data.item.showAsCarousel.jss.value');
  var title = get(fields, 'data.item.title');
  var description = get(fields, 'data.item.description');
  useEffect(function () {
    if (!pageEditing) {
      if (!hasItems) {
        if (showAsCarousel) {
          var child = document.querySelector('.media-carousel__wrapper');
          // @ts-ignore
          var parentCarousel = child.closest('.container');
          // @ts-ignore
          var grandParentCarousel = parentCarousel.parentElement.closest('.container');
          // @ts-ignore
          grandParentCarousel.style.display = 'none';
        } else {
          hideContainerByChild('.media-wrapper', '.container');
        }
      }
    }
  }, [hasItems, showAsCarousel]);
  if (!fields) {
    console.warn('MediaGrid component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [MediaGrid component is empty: please provide data source]");
    }
    return null;
  }
  return items && items.length ? /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    oneItem: items.length === 1,
    showAsCarousel: showAsCarousel
  }, !showAsCarousel && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "media-carousel-header row m26-media-grid"
  }, title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "media-carousel-header__title col-md-8"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "media-carousel-header__title-text",
    field: title.jss,
    "data-cy": "media-carousel-media-title"
  }), description && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "media-carousel-header__description media-carousel-header__description--gray",
    field: description.jss,
    "data-cy": "media-carousel-media-description"
  }))))), !showAsCarousel ? /*#__PURE__*/React.createElement("div", {
    className: "media-wrapper m26-media-grid",
    "data-cy": "media-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "media-wrapper__grid"
  }, items.map(function (item, index, array) {
    if (array.length <= 2) {
      var _cropStr = array.length === 1 ? '&cw=1420&ch=800' : '&cw=700&ch=700';
      var _src = "".concat(item.image.jss.value.src).concat(_cropStr);
      var _srcMobile = "".concat(item.image.jss.value.src).concat(array.length === 1 ? '&cw=325&ch=244' : '&cw=325&ch=325');
      return /*#__PURE__*/React.createElement("div", {
        key: item.image.jss.value.src,
        className: "media-wrapper__grid-item",
        "data-cy": "media-grid-item",
        style: array.length === 1 ? {
          width: "100%"
        } : {}
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: _src
      }), /*#__PURE__*/React.createElement("img", {
        src: _srcMobile,
        alt: item.image.jss.value.alt
      })));
    }
    var cropStr = !(index % 3) || !(index % 4) ? '&cw=700&ch=525' : '&cw=700&ch=700';
    var src = "".concat(item.image.jss.value.src).concat(cropStr);
    var showFullWidthImagesLogic = index % 3 === 0;
    var srcGrid = "".concat(item.image.jss.value.src).concat(showFullWidthImagesLogic ? '&cw=1420&ch=800' : '&cw=700&ch=525');
    var cropStrMobile = !(index % 3) || !(index % 4) ? '&cw=325&ch=242' : '&cw=325&ch=325';
    var srcCollageMobile = "".concat(item.image.jss.value.src).concat(cropStrMobile);
    var srcMobile = "".concat(item.image.jss.value.src).concat(showFullWidthImagesLogic ? '&cw=325&ch=244' : '&cw=160&ch=118');
    return showFullWidthImages === false ? /*#__PURE__*/React.createElement("div", {
      key: item.image.jss.value.src,
      className: "media-wrapper__grid-item",
      "data-cy": "media-grid-item"
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: src
    }), /*#__PURE__*/React.createElement("img", {
      src: srcCollageMobile,
      alt: item.image.jss.value.alt
    }))) : /*#__PURE__*/React.createElement("div", {
      key: item.image.jss.value.src,
      className: "media-wrapper__grid-item hight-fix ".concat(showFullWidthImagesLogic ? 'full-width' : '', " "),
      "data-cy": "media-grid-item"
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: srcGrid
    }), /*#__PURE__*/React.createElement("img", {
      src: srcMobile,
      alt: item.image.jss.value.alt
    })));
  })), hasCaption && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "media-wrapper__image-caption media-wrapper-grid__txt",
    field: fields.data.item.caption.jss
  })))) : /*#__PURE__*/React.createElement(MediaCarousel, {
    fields: {
      data: {
        playButtonAnalytics: eventsAnalytics['playButtonAnalytics'] || {},
        mobileSlidesAnalytics: eventsAnalytics['mobileSlidesAnalytics'] || {},
        nextPrevAnalytics: eventsAnalytics['nextPrevAnalytics'] || {},
        navBubblesAnalytics: eventsAnalytics['navBubblesAnalytics'] || {},
        items: fields.data.item
      }
    },
    params: params
  })) : null;
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter,
    showAsCarousel = _ref2.showAsCarousel,
    oneItem = _ref2.oneItem;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStylesSpecific, " ").concat(!oneItem ? !showAsCarousel && modileEdgeStyles : '')
  }, children);
};
var modileEdgeStyles = "m18ms75b";
var commonStylesSpecific = "c199e7kg";
export default MediaGrid;